// Shared GraphQL selection sets, interpolated into queries/mutations to avoid
// duplicating these large blocks. GraphQL ignores whitespace, so the assembled
// query text is identical to the original inlined selections.

export const SLIDE_FIELDS = `
  slideType
  textColor
  background
  decor
  box {
    boxShape
    boxBackColor
  }
  ... on EmbedSlide {
    id
    slideType
    background
    decor
    box {
      boxShape
      boxBackColor
    }
    textColor
    embedSlideText: text
    embedSlideCaption: caption
    embedSlideCaptionTitle: captionTitle
    embedUrl
  }
  ... on FullImageSlide {
    id
    slideType
    background
    decor
    box {
      boxShape
      boxBackColor
    }
    textColor
    FullImageSlideImage: image {
      type
      url
      description
    }
    caption
    captionTitle
  }
  ... on FullTextSlide {
    id
    slideType
    textColor
    background
    decor
    box {
      boxShape
      boxBackColor
    }
    FullTextSlideText: text
  }
  ... on PortraitSlide {
    id
    slideType
    background
    decor
    box {
      boxShape
      boxBackColor
    }
    textColor
    PortraitSlideImage: image {
      type
      url
      description
    }
    PortraitSlideText: text
  }
  ... on QuizSlide {
    id
    slideType
    background
    decor
    box {
      boxShape
      boxBackColor
    }
    textColor
    quizType
    question
    opt1 {
      text
      image
    }
    opt2 {
      text
      image
    }
    opt3 {
      text
      image
    }
    opt4 {
      text
      image
    }
    correctAnswer
  }
  ... on QuoteSlide {
    id
    slideType
    background
    decor
    box {
      boxShape
      boxBackColor
    }
    textColor
    QuoteSlideImage: image {
      type
      url
      description
    }
    author
    authorTitle
    text
  }
  ... on TextImageSlide {
    id
    slideType
    textColor
    background
    decor
    box {
      boxShape
      boxBackColor
    }
    SlideImage: image {
      type
      url
      description
    }
    text
  }
  ... on TitleSlide {
    id
    slideType
    textColor
    background
    decor
    tagBox {
      tagBoxBackColor
      tagBoxTextColor
      tagBoxText
    }
    box {
      boxShape
      boxBackColor
    }
    title
    description
    image {
      type
      url
      description
    }
  }
`

export const BODY_SLICES = `
  ... on BodyEmbedSlice {
    sliceType
    embedUrl
    embedText
    embedCaption
    embedCaptionTitle
  }
  ... on BodyImageSlice {
    sliceType
    imgUrl
    imgCaption
    imgCaptionTitle
  }
  ... on BodyQuoteSlice {
    sliceType
    quoteText
    author
    authorTitle
  }
  ... on BodyTextSlice {
    sliceType
    text
  }
`
